/**
 * Constants used throughout the application for consistency.
 *
 * @enum {string}
 * @readonly
 */
export enum CONSTANTS {
	POWERED_BY = "Powered by Satisfi Labs",
	WELCOME_MESSAGE = "Welcome to the platform!",
	ERROR_MESSAGE = "Something went wrong. Please try again.",
	SENDING_MESSAGE = "Sending...",
	PLACEHOLDER_TEXT = "Ask a question",
	TAGLINE_URL = "https://satisfilabs.com/",
	// SD-13787: shown in the chat body when an admin types `!login` while already logged in.
	// Admin mode is an internal tool and its trigger keywords are not localised, so this
	// string is not page-configurable either.
	ADMIN_MODE_ALREADY_ACTIVE_MESSAGE = "You're already logged in."
}
